import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes, 
  useLocation } from "react-router-dom";

import Preloader from "../src/components/Pre";
import About from "./components/About/About";
import Footer from "./components/Footer";
import Home from "./components/Home/Home";
import Navbar from "./components/Navbar";
import Privacy from "./components/Privacy/Privacy";
import Projects from "./components/Projects/Projects";
import Resume from "./components/Resume/ResumeNew";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const Instagram = () => {
    window.location.href = "https://instagram.rlchandani.dev/";
  };

  const Twitter = () => {
    window.location.href = "https://twitter.rlchandani.dev/";
  };

  const LinkedIn = () => {
    window.location.href = "https://linkedin.rlchandani.dev/";
  };

  const Github = () => {
    window.location.href = "https://github.rlchandani.dev/";
  };

  const Hopper = () => {
    let query = useQuery();
    window.location.href = `https://hopper.rlchandani.dev/?${query}`;
  };

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project" element={<Projects />} />
          <Route path="/about" element={<About />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/instagram" element={<Instagram />} />
          <Route path="/twitter" element={<Twitter />} />
          <Route path="/linkedin" element={<LinkedIn />} />
          <Route path="/github" element={<Github />} />
          <Route path="/hopper" element={<Hopper />} />
          <Route path="*" element={<Navigate to="/"/>} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
